import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
//react-icons/lib/fa/linkedin-square
import { SocialLinks } from './SocialLinks';

export class Contact extends Component {
	render() {
		return (
			<div className="content-container contact-container">
				<h1 className="punch-headline"><a href="mailto:will@dangercode.net" target="_blank" rel="noopener noreferrer">Contact Me</a></h1>
				<div className="paragraph-lead">
					<a href="mailto:will@dangercode.net" target="_blank" rel="noopener noreferrer">will@dangercode.net</a>
					<SocialLinks />
					<p className="address">
						Olympic Mills Commerce Center<br />
						107 SE Washington St<br />
						Suite 430<br />
						Portland, OR 97214
					</p>
				</div>
			</div>
		)
	}
};

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js